import { Link, useParams } from 'react-router-dom';
import { E2NTableCell } from '../../../../components/Table';
import { Antrag, Arbeitszeit } from '../../entities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { memo } from 'react';

export const EditAntragCell = memo(function EditAntragCell({
  arbeitszeit,
}: {
  arbeitszeit: Antrag | Arbeitszeit;
}) {
  const { year, month, day } = useParams();

  const linkToAntrag =
    arbeitszeit instanceof Arbeitszeit
      ? `/arbeitszeiten/uebersicht/${year}/${month}/${day}/sheet/antrag/${arbeitszeit.antraege[0].id}`
      : `/arbeitszeiten/uebersicht/${year}/${month}/${day}/sheet/antrag/${arbeitszeit.id}`;

  return (
    <E2NTableCell className="rounded-r-lg w-40 p-4">
      <Link to={linkToAntrag}>
        <FontAwesomeIcon icon={faEdit} className="text-primary-blue-B600" />
      </Link>
    </E2NTableCell>
  );
});
